import { useEffect, useState } from "react";
import InputAddressComponent from "./inputAddressComponent";

function DisplayAddressComponent(props) {

    const [innerDa , setInnerDa] = useState(props.deliveryAddresses)

    useEffect(()=>{
        
        setInnerDa(props.deliveryAddresses)
        //rederInputAddress(props.deliveryAddresses, props.setDeliveryAdderss)
})

const showda = (da) => {
    
    return true
}

const rederInputAddress = (da , sda) => {
    return (
    <>
     
     <InputAddressComponent title={"Enter Pickup Address"} addressType={"pickUpLocation"} deliveryAddresses={da}  setDeliveryAdderss={sda} validation={props.validation}/>
                        <InputAddressComponent title={"Enter Drop-off Address"} addressType={"dropOffLocation"} deliveryAddresses={da}  setDeliveryAdderss={sda} validation={props.validation}/>
                        { showda(da) &&
                        da.dropOffLocation.address && [...Array(da.additionalStops.length < 5 ? da.additionalStops.length + 1 : 5).keys()].map((i)=>{
                             
                                return (            
                                    <InputAddressComponent key={da.additionalStops[i] ? da.additionalStops[i].address : i } title={`${i+1} +Add Stops`} addressType={"additionalStops"} stopNumber={i}  deliveryAddresses={da}  setDeliveryAdderss={sda}
                                    validation={props.validation}/>
                                    )
                            })
                        }
     </>)
}
   return (
    rederInputAddress(props.deliveryAddresses, props.setDeliveryAdderss)
   )
}

export default DisplayAddressComponent;